export default __webpack_public_path__ + "static/media/wordcloud.e370738a.png";